import { FBUploadActionTypes, TFBUploadActions } from './actions';

interface IFBUploadState {
  settingsType: string;
  menuItemAtBundleModal: string;
}

const initialState: IFBUploadState = {
  settingsType: 'Конверсии',
  menuItemAtBundleModal: 'КАМПАНИИ',
};

export const fbUploadReducer = (state = initialState, action: TFBUploadActions): IFBUploadState => {
  switch (action.type) {
    case FBUploadActionTypes.SET_SETTINGS_TYPE:
      return { ...state, settingsType: action.payload };
    case FBUploadActionTypes.SET_MENU_ITEM_AT_BUNDLE_MODAL:
      return { ...state, menuItemAtBundleModal: action.payload };
    default:
      return state;
  }
};
